<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="'Back'" (addEvent)="goBackToList($event)"> </app-breadcrumb>
    <div class="container-fluid">
      <app-owner-overview (profileDetailsEvent)="getUserDetails($event)"></app-owner-overview>

      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="card">
          <div class="card-header-line">
            <div class="row">
              <div class="col-xl-6">
              </div>
              <div class="col-xl-6">
                <a *ngIf="checkUserAdditionalInfoEdit" class="badge badge-success strong border-0 m-3 float-end"
                   [class.c-pointer]="hasChanges" [class.opacity-50]="!hasChanges || loadingService.isLoading()"
                   href="javascript:void(0);" (click)="onSave()">
                  Save
                </a>
              </div>
            </div>
          </div>
          <div class="card-body">
            <textarea class="form-control additional-info" rows="12" placeholder="Add any additional information here..."
              [(ngModel)]="additionalInfo" [readonly]="!checkUserAdditionalInfoEdit"></textarea>
          </div>
        </div>
      </div>
    </div>
</div>
